<template>
  <div class="test1-container">
    <div id="wechat-web-container" class="hidden">
      <p style="text-align: center">即将跳转到小程序</p>
      <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_2d3b90474b81"
        path="pages/index"
      >
        <template>
          <button
            style="width: 200px; height: 45px;
            text-align: center; font-size: 17px; display: block;
            margin: 0 auto; padding: 8px 24px; border: none; border-radius: 4px;
            background-color: #07c160; color:#fff;margin-bottom: 0.6rem"
          >
            跳转
          </button>
        </template>
      </wx-open-launch-weapp>

      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_2d3b90474b81"
        path="pages/index"
      >
        <template>
          <button
            style="width: 200px; height: 45px;
            text-align: center; font-size: 17px; display: block;
            margin: 0 auto; padding: 8px 24px; border: none; border-radius: 4px;
            background-color: #07c160; color:#fff;margin-bottom: 0.6rem"
          >
            跳转1
          </button>
        </template>
      </wx-open-launch-weapp>

      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_2d3b90474b81"
        path="pages/index/index"
      >
        <template>
          <button
            style="width: 200px; height: 45px;
            text-align: center; font-size: 17px; display: block;
            margin: 0 auto; padding: 8px 24px; border: none; border-radius: 4px;
            background-color: #07c160; color:#fff;margin-bottom: 0.6rem"
          >
            跳转2
          </button>
        </template>
      </wx-open-launch-weapp>
      <el-button type="primary" round @click="click">跳转3</el-button>

      <iframe style="overflow: auto" width="200" height="200" src="/test.html"></iframe>

    </div>
  </div>
</template>

<script>
export default {
  name: "test1",
  components: {},
  data() {
    return {
      route: {}
    };
  },
  created() {
    this.route = this.$route.query;
  },
  mounted() {
    this.$wx.config({
      debug: true, // 调试时可开启
      appId: 'wx3cf4a63128c87f6e', //
      timestamp: 0, // 必填，填任意数字即可
      nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
      signature: 'signature', // 必填，填任意非空字符串即可
      jsApiList: ['chooseImage'], // 必填，随意一个接口即可
      openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
    });
    document.addEventListener("WeixinOpenTagsError", function(e) {
      alert(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    });
  },
  destroyed() {},
  methods: {
    click() {
    },
    click2() {

    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";

.test1-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
